var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA3LightDimDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.24 51.73l2.82 2.83L13 61.63l-2.84-2.83 7.08-7.07zM32 69h4V59h-4v10zM13 36H3v4h10v-4zm21.34 13.92A11.87 11.87 0 0126.55 47a11.997 11.997 0 01-1.84-2c-.1-.14-.21-.28-.31-.43a11.618 11.618 0 01-1-1.77A11.86 11.86 0 0126 29.5a12.09 12.09 0 014-2.59V18h8v8.68a11.88 11.88 0 014 2.22c.11.09.21.2.32.3l3.3-2.39A16.2 16.2 0 0042 24.06v-7.15a8 8 0 00-16 0v7.56a15.82 15.82 0 00-5.85 20.7c.313.634.67 1.246 1.07 1.83a15.89 15.89 0 0026.23 0h-5.33a11.86 11.86 0 01-7.78 2.92zm13.6 4.64L55 61.63l2.82-2.83-7.08-7.07-2.8 2.83zM73 12v31H30l28.75-20.73L73 12zm-3 18H54v4h16v-4z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A3_Light_dim_down.b1375998.svg";
export { SvgA3LightDimDown as ReactComponent };